import { getAuthAxiosBackend } from "@/helpers/axios"

class IssuersOldIdentificationCardsServices {
    get(id) {
        return getAuthAxiosBackend().get('IssuersOldIdentificationCards/getIssuersOldIdentificationCardsById/' + id.toString())
    }

    getAll(data = {}) {
        return getAuthAxiosBackend().get('IssuersOldIdentificationCards/all', { params: data })
    }

    add(data) {
        return getAuthAxiosBackend().post('IssuersOldIdentificationCards/addIssuersOldIdentificationCards', data)
    }

    edit(id, data) {
        return getAuthAxiosBackend().put('IssuersOldIdentificationCards/updateIssuersOldIdentificationCards/' + id, data)
    }

    restore(id, data) {
        return getAuthAxiosBackend().put('IssuersOldIdentificationCards/restoreIssuersOldIdentificationCards' + id, data)
    }

    delete(id) {
        return getAuthAxiosBackend().delete('IssuersOldIdentificationCards/softDeleteIssuersOldIdentificationCards/' + id.toString())
    }

    forceDelete(id) {
        return getAuthAxiosBackend().delete('IssuersOldIdentificationCards/deleteIssuersOldIdentificationCards/' + id.toString())
    }
}

export default new IssuersOldIdentificationCardsServices()
